<template>
  <div v-if="hasTeamActivity(activity)">
    <div class="d-flex justify-content-between mb-3" v-if="!hideTopBar">
      <div
        class="bold team-name text-large d-flex align-items-center"
        @click="expanded = !expanded"
        v-no-capture
      >
        <collapse-caret
          class="flex-shrink-0 collapse-caret row-item mr-2"
          :size="23"
          :expanded="expanded"
        />
        <template v-if="activity.team">
          {{ activity.team.name }}
        </template>
        <template v-else>
          {{ org.name }}
        </template>
      </div>
      <div class="flex-center" v-if="timeline">
        <i class="calendar-icon"></i
        ><span class="pl-2 text-nowrap"
          >{{ getDate(timeline.startDate) }}
          <span v-if="timeline.startDate && timeline.startDate.getDate() !== today.getDate()">
            - {{ getDate(today) }}</span
          ></span
        >
      </div>
    </div>
    <b-collapse v-model="expanded">
      <template v-for="(goalActivity, index) in activity.goalGroups">
        <goal-activity
          class="mb-4"
          :org-id="orgId"
          :activity="goalActivity"
          :key="index"
          @awarded="$emit('awarded')"
          @reacted="$emit('reacted')"
          v-if="hasActivity(goalActivity)"
        />
      </template>
    </b-collapse>
  </div>
</template>

<script>
import CollapseCaret from '@/components/CollapseCaret'
import { BCollapse } from 'bootstrap-vue'
import GoalActivity from '@/components/activity/GoalActivity'
import { MONTHS_SHORT } from '@/utils/formatDate'

/**
 * This component shows activities of a team/org
 */
export default {
  name: 'Activity',
  props: ['activity', 'orgId', 'timeline', 'hideTopBar'],
  components: {
    GoalActivity,
    BCollapse,
    CollapseCaret
  },
  data() {
    return {
      expanded: true
    }
  },
  computed: {
    org() {
      return this.$store.getters.orgById(this.orgId)
    },
    today() {
      return new Date()
    }
  },
  methods: {
    hasActivity(goalActivity) {
      return goalActivity.keyResultGroups
        .filter(krGroup => krGroup.keyResult)
        .some(kr => {
          return (
            kr.closedInitiativeEvents.length ||
            kr.initiativeStatusEvents.length ||
            kr.newInitiativeEvents.length ||
            kr.checkinEvents.length ||
            kr.commentEvents.length ||
            kr.closeReopenEvents.length ||
            kr.initiativeCommentEvents.length ||
            kr.goalAwardEvents.length ||
            kr.initiativeAwardEvents.length
          )
        })
    },
    hasTeamActivity(activity) {
      const goalGroups = activity.goalGroups || []
      return goalGroups.some(goalGroup => this.hasActivity(goalGroup))
    },
    getDate(date) {
      return `${date.getDate()} ${MONTHS_SHORT[date.getMonth()]}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.team-name {
  padding-left: 12px;
  color: $brand-2;
  &:hover .collapse-caret /deep/ .caret {
    opacity: 1;
  }
}
@include media-breakpoint-down(md) {
  .team-name {
    padding: 0;
  }
}
</style>
